import endpoints from '@/utils/endpoints.js'
import router from '@/router'
import moment from 'moment'
import axios from '@/utils/init-axios.js'

export default {
  login({ commit }, credentials) {
    return new Promise((resolve, reject) => {
      axios
        .post(endpoints.createBlytzTokenObtainPair(), credentials)
        .then(res => {
          const accessToken = res.data.access
          const refreshToken = res.data.refresh
          localStorage.setItem('blytzpay_access_token', accessToken)
          localStorage.setItem('blytzpay_refresh_token', refreshToken)
          commit('setTokens', { accessToken, refreshToken })
          axios.defaults.headers.common[
            'Authorization'
          ] = `Bearer ${accessToken}`
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  logout({ commit }) {
    commit('setTokens', { accessToken: null, refreshToken: null })
    commit('setIsInactive', false)
    router.push({ name: 'Login' })
  },
  refreshAccess({ commit, state, getters }) {
    return new Promise((resolve, reject) => {
      if (!state.refreshToken) {
        reject('No Refresh Token')
      }
      const t = async function() {
        const claims = getters.refreshClaims
        if (
          claims.exp &&
          moment()
            .utc()
            .unix() < claims.exp
        ) {
          await axios
            .post(endpoints.createTokenRefresh(), {
              refresh: state.refreshToken
            })
            .then(res => {
              commit('setTokens', {
                accessToken: res.data.access,
                refreshToken: res.data.refresh || state.refreshToken
              })
              axios.defaults.headers.common[
                'Authorization'
              ] = `Bearer ${res.data.access}`
              resolve(res)
            })
            .catch(err => reject(err))
        } else {
          reject('Invalid refresh token')
        }
      }
      t()
    })
  },
  authHeartbeat({ commit, state, getters, dispatch }) {
    /*
    handles idle logout
    Should be called every 15 seconds or so
    */
    if (!getters.isAuthenticated) {
      // if we are not authenticated bail
      return
    }

    const unixNow = moment()
      .utc()
      .unix()
    const sinceLastActivity = unixNow - state.lastActivity
    if (60 * process.env.VUE_APP_SESSION_TIMEOUT < sinceLastActivity) {
      /* Log out if session has timed out */
      dispatch('logout')
    } else if (
      60 * process.env.VUE_APP_SESSION_IDLE < sinceLastActivity &&
      state.isInactive == false
    ) {
      /* Set inactive flag based on session idle time */
      commit('setIsInactive', true)
    } else if (
      0 < getters.refreshTokenTimeToLive() &&
      getters.accessTokenTimeToLive() < 50
    ) {
      /*
      Refresh access if following conditions are met
      - Refresh token is valid
      - access token has less than 50 seconds to live
      */
      console.log('auto refresh')
      dispatch('refreshAccess')
    }
  },
  continueSession({ dispatch, commit }) {
    /* Call this when user chooses to continue their session */
    commit('setLastActivity')
    dispatch('refreshAccess')
  },
  getProfile({ commit }) {
    return new Promise((resolve, reject) => {
      axios
        .get(endpoints.listProfiles())
        .then(res => {
          const profile = res.data.results[0]
          commit('setProfile', { profile })
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  }
}
